// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { nautilus as _nautilus } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the nautilus chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 22222
 * Chain Name: Nautilus Mainnet
 * Default Block Explorer: https://nautscan.com
 * Default RPC URL: https://api.nautilus.nautchain.xyz
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { nautilus } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: nautilus,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const nautilus = createCommon({
	..._nautilus,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
